import { useState, useCallback, useEffect } from 'react';
import { StreamChat } from 'stream-chat';

import { useCurrentUser } from 'hooks';
import { GETSTREAM_API_KEY, IMGIX_HOST } from 'settings';

import { getRandomProfileImage } from '../helpers';

export default () => {
  const [chatClient, setChatClient] = useState(null);
  const { id, full_name, image, getstream_token } = useCurrentUser();
  const imageUrl = image
    ? `${IMGIX_HOST}/${image.key}?auto=format,compress`
    : getRandomProfileImage().src;

  const getClient = useCallback(async () => {
    const client = new StreamChat(GETSTREAM_API_KEY, {
      timeout: 6000,
    });
    const streamChatUser = {
      id,
      name: full_name,
      image: imageUrl,
    };

    await client.setUser(streamChatUser, getstream_token);
    setChatClient(client);
  }, []);

  useEffect(() => {
    if (!chatClient) {
      getClient();
    }
  }, [getClient, chatClient]);

  return chatClient;
};
